import React from 'react';
import {Box, Grid, Theme, useTheme} from "@mui/material";
import {SxProps} from "@mui/system/styleFunctionSx";
import {CustomTheme} from "../config/theme/theme";
import { isMobile } from 'react-device-detect';

interface PageCardProps {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  order?: number;
  children: React.ReactElement;
  sx?: SxProps<Theme>;
  outerSx?: SxProps<Theme>;
}

export function Card(props: PageCardProps) {
  return <Grid order={props.order} xs={props.xs} sm={props.sm} md={props.md}
               lg={props.lg} xl={props.xl}
               p={isMobile ? 1 : 1.5} sx={{...props.outerSx}} item>
    <Box p={5} width="100%" height="100%" boxShadow="var(--defaultBoxShadow)" sx={{
      background: (theme: any) => theme.palette.card.default,
      borderRadius: 4,
      ...props.sx
    }}>
      {props.children}
    </Box>
  </Grid>
}